import { render, staticRenderFns } from "./SupplierProductDialog.vue?vue&type=template&id=7788409b"
import script from "./SupplierProductDialog.vue?vue&type=script&lang=js"
export * from "./SupplierProductDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports